export const INTERVAL = 6000;
